import { HttpStateData } from '@/clients/http'

export type HttpState = {
  [key: string]: HttpStateData<any>
}

export function createStateObject<D>(data: D) {
  return {
    loading: false,
    success: false,
    error: null,
    data,
  }
}

export const httpInitialState: Partial<HttpState> = {}
